$(function() {

  /* お問い合わせフォームのバリデーション */
  function setMyForm2(target){
    console.log('setMyForm2');
    var ERROR_MESSAGE_CLASSNAME = 'errorMsg'; //エラー時のメッセージ要素のclass名
    var ERROR_INPUT_CLASSNAME = 'errorInput'; //エラー時のinput要素のclass名
    var errorCount = 0;
    var submitButton = $('#submitButton');
    var items = []; //チェック対象となるテキスト入力要素を格納した配列

    //項目チェックする
    var checkAll = function(){
      errorCount = 0;

      //input,textareaのチェック
      for( var i=0; i<items.length; i++ ){
        if( items[i].prop('isSuccess') == false ){
          errorCount++;
        };
      };
      console.log('errorCount:' + errorCount);
    };

    //エラーメッセージの追加
    var addErrorMessage = function(selector, msg){
      removeErrorMessage(selector);
      selector.parent('div').append('<span class="attention '+ERROR_MESSAGE_CLASSNAME+'">'+msg+'</span>');
      selector.addClass(ERROR_INPUT_CLASSNAME);
    };

    //エラーメッセージの削除
    var removeErrorMessage = function(selector){
      var msgSelector = selector.parent('div').find('.'+ERROR_MESSAGE_CLASSNAME);
      if( msgSelector.length != 0 ){
        msgSelector.remove();
        selector.removeClass(ERROR_INPUT_CLASSNAME);
      };
    };

    //input,textareaの未入力チェック
    var checkEmptyText = function(selector, msg){
      if( selector.val() == '' ||  selector.val() == null){
        addErrorMessage(selector, msg);
        selector.prop('isSuccess', false);
      }else{
        removeErrorMessage(selector);
        selector.prop('isSuccess', true);
      };
    };

    var emptyThrough = function(selector){
      if( selector.val() == '' ||  selector.val() == null){
        removeErrorMessage(selector);
        selector.prop('isSuccess', true);
      }
    };

    //radioの未入力チェック
    var checkRadioBox = function(selector, msg){
      if( selector.prop("checked")){
        removeErrorMessage(selector);
        selector.prop('isSuccess', true);
      }else{
        addErrorMessage(selector, msg);
        selector.prop('isSuccess', false);
      };
    };

    //文字列のフォーマットチェック
    function checkFormatText(selector, _mode, msg){
      var value = selector.val();
      switch(_mode){
        //全角のみ
        case 0:
          if(value.match(/^[^ -~｡-ﾟ]*$/)){
            selector.prop('isSuccess', true);
            removeErrorMessage(selector);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
        //ふりがなのみ
        case 1:
          if(value.match(/^[\u3040-\u309F]+$/)){
            selector.prop('isSuccess', true);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
        //電話番号・郵便番号
        case 2:
          if(value.match(/^[0-9\-]+$/) || value.length < 1){
            selector.prop('isSuccess', true);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
        //メールアドレスかどうか
        case 3:
          if(value.match(/^[a-zA-Z0-9!$&*.=^`|~#%'+\/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,6}$/)){
            selector.prop('isSuccess', true);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
      };
      if( selector.prop('isSuccess') == false ){
        addErrorMessage(selector, msg);
      }else{
        removeErrorMessage(selector);
      };
    };

    //初期設定
    var init = function(){
      /*target.find('input[type=button]').attr('disabled', true);*/
      //submitイベントの設定
      target.on({
        'submit': function(){
          checkAll();
        }
      });
      //input要素を配列に格納
      items = [
        target.find('input[name="username"]'), //0 氏名
        target.find('input[name="usermail"]'), //1 メールアドレス
        target.find('select[name="category"]'), //2 ご相談内容
        target.find('textarea[name="content"]'), //3 お問い合わせ内容
        target.find('input[name="agreement"]') //4 プラポリへの同意
      ];
      //input要素のプロパティを設定
      $.each(items, function(index){
        items[index].prop('isSuccess', false);
      });

      //enterキーでsubmitしてしまうのを防止する
      target.find('input[type=text]').on({
        'keypress': function(e){
          if( (e.keyCode == 13) ) return false;
        }
      });

      //0 氏名
      items[0].on({
        'blur': function(){
          checkEmptyText( items[0], '*Please enter your name.');
          checkAll();
        }
      });
      //1 メールアドレス
      items[1].on({
        'blur': function(){
          checkEmptyText( items[1], '※Please input your email address.');
          if( items[1].prop('isSuccess') ) checkFormatText( items[1], 3, '*Email address format is incorrect');
          checkAll();
        }
      });
      //2 ご相談内容
      items[2].on({
        'change': function(){
          checkEmptyText( items[2], '*Please select an item.');
          checkAll();
          console.log($('select[name=category]').val());
          if($('select[name=category]').val() == 1){
            $('#nominationForm').css({'display':'flex'});
          }else{
            $('#nominationForm').css({'display':'none'});
          }
        }
      });

      //3 お問い合わせ内容
      items[3].on({
        'blur': function(){
          checkEmptyText( items[3], '*Please enter the content of your inquiry.');
          checkAll();
        }
      });
      //5 プラポリへの同意
      items[4].on({
        'click': function(){
          checkRadioBox( items[4], '*Please agree to the privacy policy.');
          checkAll();
        }
      });
      submitButton.on({
        'click': function(){
          checkEmptyText( items[0], '*Please enter your name.');
          checkEmptyText( items[1], '※Please input your email address.');
          if( items[1].prop('isSuccess') ) checkFormatText( items[1], 3, '*Email address format is incorrect');
          checkEmptyText( items[2], '*Please select an item.');
          checkEmptyText( items[3], '*Please enter the content of your inquiry.');
          checkAll();
          if( errorCount == 0 ){
            processOrderContent();
          }else{
            alert('There is a problem with the input content. Please check the contents and try again.');
            var scrollHeight = $('#contact').offset().top;
            $("html, body").animate({
              scrollTop: scrollHeight
            }, 300);
          };
        }
      })
    };

    function processOrderContent(){
      submitButton.addClass('disabled');
      $('#ajaxLoader').addClass('loading');
      //0 氏名
      var userName = target.find("input[name=username]").val();
      //1 メールアドレス
      var userMail = target.find("input[name=usermail]").val();
      //2 ご相談内容
      var category = target.find("select[name=category] option:selected").attr('content');
      //3 案件依頼希望
      var nomination = target.find("select[name=nomination]").val();
      //4 お問い合わせ内容
      var content = target.find("textarea[name=content]").val();
      event.preventDefault();
      $.ajax({
        url: "https://docs.google.com/forms/u/0/d/e/1FAIpQLSeiBwopbI4fwH8MaqoANFu-8OWBQ8YEh6lQqLDPnQaj9O9jCg/formResponse",
        data: {
          "entry.405531372": userName,
          "entry.1363184816": userMail,
          "entry.341784418": category,
          "entry.308552250": nomination,
          "entry.413367977": content,
        },
        type: "POST",
        dataType: "xml",
        statusCode: {
          0: function () {
            setTimeout(function() {
              $('#ajaxLoader').removeClass('loading');
              $('#submitButton').addClass('completed');
              $('#statusMessage').addClass('complete').html('<span class="text">Your message has been sent. Please check your auto-reply email.</span>');
            }, 1000);
          },
          200: function () {
            $('#ajaxLoader').removeClass('loading');
            $('#submitButton').addClass('completed');
            $('#statusMessage').addClass('error').html('<span class="text">Failed to send message. We apologize for the inconvenience, but please try again later.</span>');
          }
        }
      });
    }

    init();

  };

  if (document.getElementById('contactForm')) {
    setMyForm2($('#contactForm'));
  }



});
